import getText from "../../../../../utils/language.js"
import { GlobalContext } from "../../../../../utils/globalprovider.js";
import "./tabs.css"
import React from "react";

class ParamTitle extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)

    }
    render()
    {
        var title = "";
        if ("textdirect" in this.props)
            title = this.props.textdirect;
        else
            title = getText(this.props.text.cat, this.props.text.scat, this.context.language);

        
        return(
            <div className ="tabsettingtitle">
                {title}
            </div>
        )
    }
}

export default ParamTitle
